// extracted by mini-css-extract-plugin
export var measureBox = "_bl-0";